import { LlavesConfiguraciones } from "./Llaves/RepositorioConfig";

// Configuraciones generales que se usan en el manejo del sitio
const Config = {
    rutaPublicacion: LlavesConfiguraciones.rutaPublicacion,         /* Server donde se publica la aplicacion para desarrollo seria vacia y en el IIS la ruta que contiene al app Ejms (/MODULOS/App) */
    tiempoSesion: LlavesConfiguraciones.tiempoSesion,          /*Se usa para indicar el tiempo en milisegundos que se tiene para mantener la sesion al completarse debe de salir de la sesion y regresar a login  */
    moduloActual: LlavesConfiguraciones.moduloActual,        /*Codigo del modulo actual (usado para operaciones de seguridad)*/
    urlModuloLogin: LlavesConfiguraciones.urlModuloLogin  /*En caso de vencer el tiempo de sesion o para otras operaciones representa la url del sitio de login */
  };

export default Config; 